function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { Help } from '../../common/icons';
import { Tooltip } from '../tooltip';

function compatibleAlign(align) {
  if (align === 'left') {
    return 'start';
  }

  if (align === 'right') {
    return 'end';
  }

  return align;
}

export function FormContainer(props) {
  var _props$hasLabel = props.hasLabel,
      hasLabel = _props$hasLabel === void 0 ? true : _props$hasLabel,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$align = props.align,
      propAlign = _props$align === void 0 ? 'end' : _props$align,
      _props$colon = props.colon,
      colon = _props$colon === void 0 ? false : _props$colon,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      labelWidth = props.labelWidth,
      className = props.className,
      label = props.label,
      _props$inline = props.inline,
      inline = _props$inline === void 0 ? false : _props$inline,
      children = props.children,
      tooltip = props.tooltip,
      _props$tooltipPlaceme = props.tooltipPlacement,
      tooltipPlacement = _props$tooltipPlaceme === void 0 ? 'top' : _props$tooltipPlaceme,
      tooltipOffset = props.tooltipOffset,
      tooltipArrowOffset = props.tooltipArrowOffset,
      _props$tooltipMode = props.tooltipMode,
      tooltipMode = _props$tooltipMode === void 0 ? 'dark' : _props$tooltipMode,
      hint = props.hint,
      help = props.help,
      status = props.status,
      _props$level = props.level,
      level = _props$level === void 0 ? 1 : _props$level,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? false : _props$vertical,
      extra = _objectWithoutProperties(props, ["hasLabel", "size", "align", "colon", "required", "labelWidth", "className", "label", "inline", "children", "tooltip", "tooltipPlacement", "tooltipOffset", "tooltipArrowOffset", "tooltipMode", "hint", "help", "status", "level", "vertical"]);

  var align = compatibleAlign(propAlign);
  var rtl = useDirection() === 'rtl';
  var wrapperCls = classnames(usePrefixCls('form-container', {
    size: size,
    level: typeof level === 'number' ? String(level) : false,
    inline: inline,
    vertical: vertical,
    'with-help': !!help,
    'with-hint': !!hint,
    rtl: rtl
  }), className);
  var labelCls = usePrefixCls('form-container-label', {
    required: required,
    align: align,
    size: size,
    vertical: vertical,
    rtl: rtl
  });
  var contentCls = classnames(usePrefixCls('form-container-content', {
    rtl: rtl
  }), {
    'has-success': status === 'success',
    'has-warning': status === 'warning',
    'has-error': status === 'error',
    'is-validating': status === 'validating'
  });
  var colonCls = usePrefixCls('form-container-label-colon');
  var tooltipCls = usePrefixCls('form-container-label-tooltip');
  var tooltipIconCls = usePrefixCls('form-container-label-tooltip-icon');
  var hintCls = usePrefixCls('form-container-hint');
  var helpCls = usePrefixCls('form-container-help');

  var renderTooltip = function renderTooltip() {
    if (!tooltip) {
      return null;
    }

    return React.createElement(Tooltip, {
      className: tooltipCls,
      trigger: "hover",
      content: tooltip,
      placement: tooltipPlacement,
      offset: tooltipOffset,
      arrowOffset: tooltipArrowOffset,
      mode: tooltipMode
    }, React.createElement(Help, {
      className: tooltipIconCls
    }));
  };

  var renderLabel = function renderLabel() {
    if (!hasLabel) {
      return null;
    }

    return React.createElement("label", {
      className: labelCls,
      style: {
        width: labelWidth !== undefined ? "".concat(labelWidth, "px") : undefined
      }
    }, renderTooltip(), label, colon && React.createElement("span", {
      className: colonCls
    }, ":"));
  };

  var renderHint = function renderHint() {
    if (!hint) {
      return null;
    }

    return React.createElement("div", {
      className: hintCls
    }, hint);
  };

  var renderHelp = function renderHelp() {
    if (!help) {
      return null;
    }

    return React.createElement("div", {
      className: helpCls
    }, help);
  };

  return React.createElement("div", Object.assign({
    className: wrapperCls
  }, extra), renderLabel(), React.createElement("div", {
    className: contentCls
  }, children, renderHelp(), renderHint()));
}